module.exports = __webpack_public_path__ + "/static/images/config.title-en-US.png";